import { fetchAddressByCep } from "services/cep/viaCepGateway";
import { fetchViability } from "services/cep/shippingViabilityGateway";
import { isValidCep } from "utils/formatters";

const INVALID_CEP = "Informe um CEP válido com 8 dígitos.";
const CEP_NOT_FOUND = "CEP não encontrado. Confira o número digitado.";
const GENERIC_ERROR =
  "Não foi possível consultar agora. Tente novamente em instantes.";

const checkViabilityByUf = (viabilityUrl, uf) =>
  fetchViability(viabilityUrl, uf)
    .then((data) => ({
      ok: true,
      uf,
      viable: data.viable,
      status: data.status,
      message: data.message,
    }))
    .catch((error) => ({
      ok: false,
      message: error.response?.data?.error || GENERIC_ERROR,
    }));

const checkViabilityByCep = (viabilityUrl, cep) => {
  if (!isValidCep(cep)) return Promise.resolve({ ok: false, message: INVALID_CEP });

  return fetchAddressByCep(cep)
    .then((address) => {
      if (address.erro) return { ok: false, message: CEP_NOT_FOUND };

      return checkViabilityByUf(viabilityUrl, address.uf);
    })
    .catch(() => ({ ok: false, message: GENERIC_ERROR }));
};

export { checkViabilityByCep, checkViabilityByUf };
